import React from 'react'
import styled from 'styled-components'
import Button from '@app.components/Button'
import { useDutyModalStore } from '../../store/dutyModal'

const BackButton: React.FC = () => {
  const variables = useDutyModalStore((store) => store.variables)
  const setVariables = useDutyModalStore((store) => store.setVariables)

  const handleClick = () => {
    if (!variables?.filterBy) return

    setVariables({
      ...variables,
      filterBy: {
        ...variables.filterBy,
        query: '',
      },
    })
  }

  return (
    <StyledWrapper>
      <Button className="back-button" onClick={handleClick}>
        목록으로 돌아가기
      </Button>
    </StyledWrapper>
  )
}

export default BackButton

const StyledWrapper = styled.span`
  .back-button {
    font-size: 12px;
    padding: 6px 18px;
  }
`
